import transactionTypes from 'constants/transactionTypes';
import operationTypes from 'constants/operationTypes';

import { Operation, Transaction } from 'types';
import { getTransactionSharesCount } from './getTransactionSharesCount';

const getOperationShares = (operation: Operation) => {
  const transactions = operation?.transactions?.filter(
    (transaction) =>
      (transaction as Transaction).transactionType !==
        transactionTypes.ADD_PARTNER &&
      (transaction as Transaction).transactionType !== transactionTypes.SELL
  ) as Transaction[];

  if (!transactions.length) return null;

  return transactions?.reduce(
    (acc, transaction) => acc + getTransactionSharesCount(transaction),
    0
  );
};

export const getOperationSharesCount = (operation: Operation) => {
  if (!operation) return null;

  switch (operation.operationType) {
    case operationTypes.RECLASSIFICATION:
    case operationTypes.SPLIT: {
      return 0;
    }

    default: {
      const operationShares = getOperationShares(operation);
      return operationShares;
    }
  }
};
